module.exports = __webpack_public_path__ + "img/2.e008b15a.png";